import { combineReducers } from "redux";
import profile from "./profile/reducer";
import settings from "./settings/reducer";
import creditz from "./creditz/reducer";
import connection from "./connections/reducer";
import users from "./users/reducer"

export default () =>
  combineReducers({
    profile,
    settings,
    creditz,
    connection,
    users
  });
